import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { catchError, delay, Subscription } from 'rxjs';
import { ConfigurationService } from '../../_infrastructure/classes/services/configuration.service';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../_infrastructure/classes/handlers/exceptionManager';
import { ComponentBase } from '../../_infrastructure/classes/componentBase';
import { TogglerService } from '../../_infrastructure/classes/services/toggler.service';
import { LoggedUserViewModel } from '../../_infrastructure/types/common';

@Component({
    selector: 'app-header-cexveg',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends ComponentBase implements OnInit, OnDestroy {
    @Input() sidebarId = 'sidebar';

    logo = 'assets/images/logo.png';
    private casKeyValue: any;
    private sidebarMinimized = true;
    sidebarShown$ = this.togglerService.visibility$.pipe(delay(500)); // Así evitamos el error "ExpressionHasChanged", que se producía al arrancar por primera vez.

    loginPanelShown$ = this.togglerService.loginPanelObservable$.pipe(delay(500));

    togglerTitle = '';

    private subscriptions: Subscription = new Subscription();

    constructor(
        private router: Router,
        private configurationService: ConfigurationService,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private togglerService: TogglerService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.addSubscriptions();
    }

    private addSubscriptions(): void {
        this.subscriptions.add(
            this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationEnd) {
                    this.loginWebCAS(this.getCASTicket(event.url));
                }
            }),
        );

        this.subscriptions.add(
            this.configurationService.getCASEnabled().subscribe(value => {
                this.casKeyValue = value;
            }),
        );

        this.subscriptions.add(
            this.togglerService.minimizer$.subscribe(() => {
                this.sidebarMinimized = !this.sidebarMinimized;
                this.togglerTitle = this.sidebarMinimized ? 'Maximizar Menú' : 'Minimizar Menú';
            }),
        );
    }

    private loginWebCAS(ticket: string) {
        if (!ticket) {
            return;
        }

        this.subscriptions.add(
            this.authService.authenticateWebCAS(ticket).subscribe({
                next: res => {
                    if (res) {
                        this.addSuccessMessage('Sesión iniciada');
                        this.router.navigate(['/home']);
                    } else {
                        this.addErrorMessage('Error de autorización');
                        this.router.navigate(['/error/loginko']);
                    }
                },
                error: catchError(err => {
                    this.catchServerError(err);
                    return err;
                }),
            }),
        );
    }

    private getCASTicket(url: string) {
        return url.split('ticket=')[1];
    }

    login(): void {
        if (this.casKeyValue || this.casKeyValue == 'True') {
            this.router.navigate(['/mantenimiento/usuarios/login']);
            return;
        }
        if (!this.casKeyValue || this.casKeyValue == 'False') {
            this.router.navigate(['/mantenimiento/usuarios/logindev']);
            return;
        }
    }

    logOut() {
        this.authService.emitLogout();
    }

    onLogoClick(): void {
        this.router.navigate(['/']);
    }

    get isUserLogged(): boolean {
        return this.authService.isLoggedIn();
    }

    get loggedUser(): LoggedUserViewModel | null {
        return this.authService.getLoggedInUser();
    }

    public toggleMinimizerSidebar(): void {
        this.togglerService.toggleMinimizerSidebar();
    }

    public getToggleIcon(): string {
        return this.sidebarMinimized ? 'fa-chevron-right' : 'fa-chevron-left';
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
